

































































import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { mixins } from 'vue-class-component';
import PaymentStatusMixin from '@/views/layout/navigation/mixins/payment-status-mixin';

@Component
export default class NavbarPayment extends mixins(PaymentStatusMixin) { 
  @Prop({ default: '' })
  contentClass: string;

  @Prop() 
  nudgeLeft: number;

  @Prop() 
  nudgeRight: number;

  @Prop() 
  nudgeTop: number;

  @Prop() 
  nudgeBottom: number;

  @Prop()
  offsetX: boolean; 

  @Prop()
  offsetY: boolean; 

  value: boolean = false;

  get pContentClass() {
    let result = [ 'navbar-payment__menu' ];

    if(this.contentClass) {
      result.push(this.contentClass);
    }

    return result.join(' ');
  }

  get cardExpiryDate() {
    return moment(this.$store.state.user.cardExpiry).format('D MMM');
  }

  handlePaymentClick(event: any) {
    this.$emit('action', event);
    this.$router.push('/app/profile/subscription')
  }
}
